import _slicedToArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";
var _excluded = ["defaultValue", "value", "onChange", "textField", "dataKey", "data", "onKeyDown", "disabled", "readOnly", "onBlur", "onFocus", "multiple"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/* eslint-disable @typescript-eslint/no-empty-function */


import cn from 'classnames';
import React, { useMemo, useRef } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import List, { useHandleSelect } from './List';
import { useFocusList, FocusListContext } from './FocusListContext';
import * as CustomPropTypes from './PropTypes';
import { makeArray } from './_';
import { useAccessors } from './Accessors';
import { notify } from './WidgetHelpers';
import useFocusManager from './useFocusManager';
import { useWidgetProps } from './Widget';
var Listbox = /*#__PURE__*/React.forwardRef(function Listbox(_ref, _outerRef) {
  var defaultValue = _ref.defaultValue,
      propsValue = _ref.value,
      propsOnChange = _ref.onChange,
      textField = _ref.textField,
      dataKey = _ref.dataKey,
      data = _ref.data,
      onKeyDown = _ref.onKeyDown,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      multiple = _ref.multiple,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, propsOnChange),
      _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
      value = _useUncontrolledProp2[0],
      onChange = _useUncontrolledProp2[1];

  var accessors = useAccessors(textField, dataKey);
  var dataItems = useMemo(function () {
    return makeArray(value, multiple).map(function (item) {
      return accessors.findOrSelf(data, item);
    });
  }, [value, multiple, accessors, data]);
  var ref = useRef(null);
  var lastItemRef = useRef(dataItems[dataItems.length - 1]);
  var list = useFocusList({
    scope: ref,
    anchorItem: lastItemRef.current
  });
  var isDisabled = disabled === true;

  var handleChange = function handleChange(dataItem, meta) {
    if (isDisabled || readOnly) return;
    lastItemRef.current = meta.dataItem;
    onChange(dataItem, meta);
  };

  var handleSelect = useHandleSelect(!!multiple, dataItems, handleChange);

  var _useFocusManager = useFocusManager(ref, {
    disabled: isDisabled,
    onBlur: onBlur,
    onFocus: onFocus
  }, {
    didHandle: function didHandle(focused) {
      if (!focused) {
        list.focus(undefined);
      } else {
        focus({
          preventScroll: true
        });
      }
    }
  }),
      _useFocusManager2 = _slicedToArray(_useFocusManager, 2),
      focusEvents = _useFocusManager2[0],
      focused = _useFocusManager2[1];

  function focus(opts) {
    if (ref.current) ref.current.focus(opts);
  }

  var handleKeyDown = function handleKeyDown(e) {
    if (isDisabled || readOnly) return;
    var key = e.key,
        shiftKey = e.shiftKey;
    notify(onKeyDown, [e]);
    if (e.defaultPrevented) return;

    if (key === 'End' && !shiftKey) {
      e.preventDefault();
      list.focus(list.last());
    } else if (key === 'Home' && !shiftKey) {
      e.preventDefault();
      list.focus(list.first());
    } else if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      if (list.getFocused()) handleSelect(list.getFocused(), e);
    } else if (key === 'ArrowDown') {
      e.preventDefault();
      list.focus(list.next());
    } else if (key === 'ArrowUp') {
      e.preventDefault();
      list.focus(list.prev());
    }
  };

  var widgetProps = useWidgetProps({
    focused: focused,
    readOnly: readOnly,
    disabled: isDisabled,
    className: cn(props.className, 'rw-listbox rw-widget-input rw-widget')
  });
  return /*#__PURE__*/React.createElement(FocusListContext.Provider, {
    value: list.context
  }, /*#__PURE__*/React.createElement(List, _extends({}, props, widgetProps, {
    disabled: disabled,
    tabIndex: isDisabled ? -1 : 0,
    data: data,
    elementRef: ref,
    value: dataItems,
    multiple: multiple,
    accessors: accessors
  }, focusEvents, {
    onChange: handleChange,
    onKeyDown: handleKeyDown
  })));
});
Listbox.displayName = 'Listbox';
export default Listbox;